<script>
  /**
   * @type {Object} table list data
   */
  export let json

  export let selectedBadgeId = ""
</script>

<!-- card list -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click class="{selectedBadgeId == json.id ? 'border-blue-500 dark:border-green-500' : 'border-transparent hover:shadow-md dark:hover:border-blue-500'} h-full w-full rounded-md border-2 dark:border-transparent">
  <div class="group relative flex h-[70%] w-full items-center justify-center rounded-t-md bg-[#f7f7f7] dark:bg-bodyblack">
    <img src={json.uri} alt="Badge" class="aspect-auto h-auto max-h-full select-none rounded-md" style="background: url(assets/img/grid.png);" />
  </div>
  <div class="h-[30%] -translate-y-0.5 space-y-1 rounded-b-md bg-white p-3 dark:bg-lightgray">
    <h1 title={json.name} class="w-4/5 select-none truncate break-words text-sm font-bold text-black dark:text-white md:text-lg">
      {json.name}
    </h1>
    <p class="select-none truncate text-xs font-medium text-gray-500 md:text-sm">
      <!-- {new Date(template.created).toString().slice(0, 24)} -->
      {new Date(json.modified || json.created).toString().slice(0, 24)}
    </p>
  </div>
</div>

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
